import { AbelSDK, AbelSDKOptions } from 'abel-sdk'
import { algorand } from './clients'

export function getAbelSDK(appId: bigint) {

    return new AbelSDK({ algorand: algorand as unknown as AbelSDKOptions["algorand"], appId })
}